import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { MatDialog, MatSnackBar } from '@angular/material';
import * as fromModels from '@models';
import { Store } from '@ngrx/store';
import { RootState } from '@base/rootReducers';
import * as fromEtl from '@etl/etl.reducer';
import * as etlActions from '@etl/etl.actions';
import * as parameterActions from '@parameter/store/parameter.actions';
import * as etlSelectors from '@etl/etl.selectors';
import * as parameterSelectors from '@parameter/store/parameter.selectors';
import { DialogEtlComponent } from '@etl/dialog/dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as fromUtils from '@utils';
import { ModuleService } from '@base/module/module.service';
import { IModule } from '@interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { ICompany } from '@company/company.structures';
import { CompanyService } from '@company/company.service';

@Component({
  selector: 'app-etl-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.sass']
})
export class EtlListComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  private routeModuleId: number = fromUtils.EMPTY;
  private routeCompanyId: number = fromUtils.EMPTY;
  private modules: IModule[];
  private companies: ICompany[];
  private currentModule: IModule;
  currentCompany: ICompany;
  etls: Observable<fromModels.Etl[]>;
  etlServer: Observable<fromModels.Parameter>;
  isFetching: Observable<boolean>;
  etlDeleted: Subscription;
  startingJob = false;
  ROLES = fromUtils.ROLES;
  filterItems = '';
  p1 = 1;

  constructor(
    private store: Store<RootState>,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private moduleService: ModuleService,
    private companyService: CompanyService,
    private router: Router,
  ) {
    const modSubs = this.moduleService.observeCurrentModule().subscribe((m: IModule) => this.currentModule = m);
    const coSubs = this.moduleService.observeCurrentCompany().subscribe((c: ICompany) => this.currentCompany = c);
    const allModules = this.moduleService.observeModules().subscribe(
      (res: IModule[]) => {
        this.modules = res;
        this.loadInstanceInfo(this.routeModuleId, this.modules as [], this.currentModule);
      },
      (err: HttpErrorResponse) => console.log(err.message)
    );

    const allCompanies = this.companyService.observeCompanies().subscribe(
      (res: ICompany[]) => {
        this.companies = res;
        this.loadInstanceInfo(this.routeCompanyId, this.companies as [], this.currentCompany, fromUtils.COMPANY);
      },
      (err: HttpErrorResponse) => console.log(err.message)
    );
    this.subscriptions = [...this.subscriptions,
      allModules, allCompanies,
      modSubs, coSubs,
    ];
  }

  ngOnInit() {
    // captura de los parametros pasados en la URL
    this.route.params.subscribe((params) => {
      this.routeModuleId = fromUtils.getNumber(params['id']);
      this.routeCompanyId = fromUtils.getNumber(params['companyId']);
      this.loadInstanceInfo(this.routeModuleId, this.modules as [], this.currentModule);
      this.loadInstanceInfo(this.routeCompanyId, this.companies as [], this.currentCompany, fromUtils.COMPANY);
    });

    this.store.dispatch(etlActions.getCompanyJobs({companyId: this.routeCompanyId}));
    this.store.dispatch(parameterActions.getCollection());
    this.etls = this.store.select(etlSelectors.getCollection);
    this.isFetching = this.store.select(etlSelectors.fetchingCollection);
    this.etlServer = this.store.select(parameterSelectors.getModuleParams('etl'));

    const errorSubs = this.store.select(etlSelectors.getError).subscribe(
      ({error, errorType}) => {
        if (error !== null) {
          let message = '';
          this.startingJob = false;

          if (errorType === fromEtl.errorTypes.fetching) {
            message = 'No se pudo obtener los datos';
          } else if (errorType === fromEtl.errorTypes.startingJob) {
            message = 'No se pudo iniciar el Job';
          }
          this.openSnackBar(error.message, 'info');
        }
      }
    );

    this.subscriptions = [...this.subscriptions, errorSubs];
  }

  ngOnDestroy() {
    this.moduleService.setCompany(null);
    this.subscriptions.map((subscription) => subscription.unsubscribe());
  }

  private loadInstanceInfo(
    id: number, collection: [], currentInstance: object, subject = fromUtils.MODULE
  ) {
    const instance = fromUtils.loadInstanceOf(id, collection, currentInstance);
    if (instance !== fromUtils.EMPTY) {
      if (subject === fromUtils.MODULE) {this.moduleService.setCurrentModule(instance); }
      if (subject === fromUtils.COMPANY) {this.moduleService.setCompany(instance); }
    }
  }

  addProcess() {
    const etl = new fromModels.Etl();
    etl.company = this.routeCompanyId;
    this.store.dispatch(etlActions.resetParams({row: etl}));

    const params = {
      title: 'Nuevo Enlace',
      edit: false,
    };
    const dialogRef = this.dialog.open(DialogEtlComponent, {
      width: '350px',
      data: params,
      disableClose: true,
    });

    // dialogRef.afterClosed().subscribe((newEtl: Etl) => {
    //   if ((typeof newEtl !== 'undefined') && (newEtl !== null)) {
    //     console.log(newEtl);
    //   }
    // });
  }

  private openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 4000,
    });
  }

  goToCompanies() {
    this.route.params.subscribe((params) => {
      const routeModuleId = fromUtils.getNumber(params['id']);
      this.router.navigate([`home/modules`, routeModuleId]);
    });
  }
}
